import { QUERY_KEY_ENTITY, QUERY_KEY_TYPE } from '../../constants';
import { baseApi } from './base.api';

const LIST_TAG = `${QUERY_KEY_ENTITY.PUBLISHER}_${QUERY_KEY_TYPE.LIST}`;
const DROP_TAG = `${QUERY_KEY_ENTITY.PUBLISHER}_${QUERY_KEY_TYPE.DROPDOWN}`;

export const publisherApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPublishersList: build.query({
      query: () => `/v1/publisher`,
      providesTags: [{ type: LIST_TAG }],
    }),
    getPublisherDetails: build.query({
      query: (arg) => `/v1/publisher/${arg}`,
      providesTags: (res, err, arg) => [
        { type: QUERY_KEY_ENTITY.PUBLISHER, id: Number(arg) || 0 },
      ],
    }),
    getPublishersDropdown: build.query({
      query: () => `/v1/reports/publisher-list`,
      transformResponse: (data) =>
        data?.length
          ? data
              .map((item) => ({
                value: item.id,
                label: `(${item.id}) ${item.name}`,
              }))
              .sort((a, b) => b.value - a.value)
          : [],
      providesTags: [{ type: DROP_TAG }],
    }),
    updatePublisherStatus: build.mutation({
      query: (arg) => ({
        url: '/v1/publisher/update-status',
        method: 'POST',
        body: arg,
      }),
      invalidatesTags: (res, err, arg) =>
        err
          ? []
          : [
              { type: LIST_TAG },
              { type: DROP_TAG },
              ...arg.ids.map((id) => ({
                type: QUERY_KEY_ENTITY.PUBLISHER,
                id: Number(id) || 0,
              })),
            ],
    }),
    updatePublisher: build.mutation({
      query: ({ id, payload }) => ({
        url: id ? `/v1/publisher/update/${id}` : '/v1/publisher/add',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: (res, err, { id }) =>
        err
          ? []
          : [
              { type: LIST_TAG },
              { type: DROP_TAG },
              ...(id
                ? [{ type: QUERY_KEY_ENTITY.PUBLISHER, id: Number(id) || 0 }]
                : []),
            ],
    }),
  }),
});

export const {
  useGetPublishersDropdownQuery,
  useGetPublishersListQuery,
  useGetPublisherDetailsQuery,
  useUpdatePublisherStatusMutation,
  useUpdatePublisherMutation,
} = publisherApi;
